import { render } from "./index.vue?vue&type=template&id=2faf84d0&scoped=true&ts=true"
import script from "./view-model/index.ts?vue&type=script&lang=ts"
export * from "./view-model/index.ts?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2faf84d0&lang=less&scoped=true"
/* custom blocks */
import block0 from "./locales/en_US.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ccode%5Ccustomer%5Csrc%5Ccomponents%5Cgiftcard-accept%5Cindex.vue&lang=yaml&locale=en_US"
if (typeof block0 === 'function') block0(script)
import block1 from "./locales/zh_CN.yaml?vue&type=custom&index=1&blockType=i18n&issuerPath=D%3A%5Ccode%5Ccustomer%5Csrc%5Ccomponents%5Cgiftcard-accept%5Cindex.vue&lang=yaml&locale=zh_CN"
if (typeof block1 === 'function') block1(script)
import block2 from "./locales/es_ES.yaml?vue&type=custom&index=2&blockType=i18n&issuerPath=D%3A%5Ccode%5Ccustomer%5Csrc%5Ccomponents%5Cgiftcard-accept%5Cindex.vue&lang=yaml&locale=es_ES"
if (typeof block2 === 'function') block2(script)


import exportComponent from "D:\\code\\customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf84d0"],['__file',"src/components/giftcard-accept/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2faf84d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2faf84d0', __exports__)) {
    console.log('reload')
    api.reload('2faf84d0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2faf84d0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2faf84d0', render)
  })

}


export default __exports__